// extracted by mini-css-extract-plugin
module.exports = {"navBarWrapper":"NavBar_navBarWrapper__3XYjw","navBarContainer":"NavBar_navBarContainer__2nw7L","iconAltText":"NavBar_iconAltText__3wLdD","active":"NavBar_active__7J2jp"};